export const guideNavItems: { path: string; label: string }[] = [
  { path: 'getting-started', label: 'Getting started' },
  { path: 'account-subscription', label: 'Account & subscription' },
  { path: 'betfair-ai-mode', label: 'Betfair & AI Mode' },
  { path: 'races-and-betting', label: "Today's races & betting" },
  { path: 'performance-history', label: 'Performance & history' },
  { path: 'settings-digest', label: 'Settings & morning digest' },
  { path: 'troubleshooting', label: 'Troubleshooting' },
];
